import { mergeDeep } from "@perxis-auto/shared";
import { selectors } from "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
const DEFAULT_OPTIONS = {
  withoutSelectedBenefits: false
};
function useGetVehiclePrice(vehicleItem, options = DEFAULT_OPTIONS) {
  const { withoutSelectedBenefits } = mergeDeep(DEFAULT_OPTIONS, options);
  const { price, minPrice } = (vehicleItem == null ? void 0 : vehicleItem.data) || {};
  const { enable, showOnlyBlock } = useAppSelector(selectBenefits);
  const isBenefitsEnabled = enable && !showOnlyBlock;
  const benefitsSelection = useAppSelector((state) => {
    if (!vehicleItem) {
      return void 0;
    }
    return selectors.selectById(state.benefitChoice, vehicleItem.id);
  });
  if (!isBenefitsEnabled) {
    return {
      price
    };
  }
  if (!minPrice) {
    return {
      price
    };
  }
  if (withoutSelectedBenefits) {
    return {
      price: minPrice,
      oldPrice: price
    };
  }
  if (!benefitsSelection) {
    return {
      price: minPrice,
      oldPrice: price
    };
  }
  if (!price) {
    return {};
  }
  const benefitPrice = benefitsSelection.benefits.reduce((prevValue, benefit) => (benefit.value || 0) + prevValue, 0);
  return {
    price: price - benefitPrice,
    oldPrice: price
  };
}
export {
  useGetVehiclePrice
};
